/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.email_changes', [
      'admin.users.details.email_changes.service',
    ])
    .controller('EmailChangesCtrl', EmailChangesCtrl);

  /** @ngInject */
  function EmailChangesCtrl($stateParams, EmailChangesService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;

    EmailChangesService.list(vm.userId).then(function(result) {
      for (var i = 0; i < result.results.length; i++) {
        result.results[i]['ts-m'] = new Date(result.results[i]['ts-m'] / 1000);
        result.results[i]['ts'] = new Date(result.results[i]['ts'] / 1000);
        result.results[i]['ts-ev'] = new Date(result.results[i]['ts-ev'] / 1000);
      }
      vm.items = result.results;
    });
  }

})();
